<section *ngIf="tokenValid">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'alreadylogedIn' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/home">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'home' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="!tokenValid">
    <div class="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-inner text-center">
                        <h2 class="title">{{'regNow' | translate}}</h2>
                        <ul class="page-list">
                            <li class="rbt-breadcrumb-item"><a routerLink="/home">{{'home' | translate}}</a></li>
                            <li>
                                <div class="icon-right"><i class="feather-chevron-right"></i></div>
                            </li>
                            <li class="rbt-breadcrumb-item active">{{'Register' | translate}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="rbt-become-area bg-color-white rbt-section-gap">
        <div class="container">
            <div class="advance-tab-button mb--30">
                <ul class="nav nav-tabs tab-button-style-2 justify-content-center" id="settinsTab-4" role="tablist">
                    <li role="presentation">
                        <a href="#" class="tab-button active" id="teacher-tab" data-bs-toggle="tab" data-bs-target="#teacher" role="tab" aria-controls="teacher" aria-selected="true">
                            <span class="title">{{'regAsTeacher' | translate}}</span>
                        </a>
                    </li>
                    <li role="presentation">
                        <a href="#" class="tab-button" id="student-tab" data-bs-toggle="tab" data-bs-target="#student" role="tab" aria-controls="student" aria-selected="false">
                            <span class="title">{{'regAsStud' | translate}}</span>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="tab-content">
                <div class="tab-pane fade active show" id="teacher" role="tabpanel" aria-labelledby="teacher-tab">
                    <div class="rbt-default-sidebar rbt-shadow-box rbt-gradient-border" style="background: #FFF !important;border:1px solid #ff8c13">
                        <div class="inner">
                            <form #teacherForm="ngForm" id="teacherForm" novalidate>
                                <div class="row row-15">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input name="firstName" id="firstName" autocomplete="off" type="text" [(ngModel)]="teacher.firstName" required ngModel required #firstName="ngModel" placeholder="{{'First Name' | translate}}" [maxlength]="150" pattern="[أ-يa-zA-z ]*">
                                            <span class="focus-border"></span>
                                        </div>
                                        <small class="d-block mt_dec--5" *ngIf="firstName.errors?.pattern"><i class="feather-info" style="margin-left: 5px;"></i>{{'dontContain' | translate}}</small>
                                    </div>
        
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input name="lastName" id="lastName" autocomplete="off" type="text" [(ngModel)]="teacher.lastName" required ngModel required #lastName="ngModel" placeholder="{{'Last Name' | translate}}" [maxlength]="150" pattern="[أ-يa-zA-z ]*">
                                            <span class="focus-border"></span>
                                        </div>
                                        <small class="d-block mt_dec--5" *ngIf="lastName.errors?.pattern"><i class="feather-info" style="margin-left: 5px;"></i>{{'dontContain' | translate}}</small>
                                    </div>
                                </div>
        
                                <div class="row row-15">
                                    <div class="col-lg-6">
                                        <div class="form-group" style="margin-top: 15px;">
                                            <input name="userName" id="userName" autocomplete="off" type="text" [(ngModel)]="teacher.userName" required ngModel required #userName="ngModel" placeholder="{{'User name' | translate}}" [maxlength]="50">
                                            <span class="focus-border"></span>
                                        </div>
                                    </div>
        
                                    <div class="col-lg-4">
                                        <div class="form-group" style="margin-top: 15px;">
                                            <input name="mobile" id="mobile" autocomplete="off" type="text" [(ngModel)]="teacher.mobile" required ngModel required #mobile="ngModel" placeholder="{{'Phone Number' | translate}}" [maxlength]="10" NumbersOnly>
                                            <span class="focus-border"></span>
                                        </div>
                                    </div>

                                    <div class="col-lg-2">
                                        <div class="form-group" style="margin-top: 15px;">
                                            <select name="countryCode" id="countryCode" [(ngModel)]="countryCode" (ngModelChange)="onSelectTeacherCountry($event)" *ngIf="this.baseService.isRTL === true">
                                                <option value="" disabled selected>{{'countryCode' | translate}}</option>
                                                <option *ngFor="let country of countries" [value]="country.code">{{country.nameAr}}</option>
                                            </select>

                                            <select name="countryCode" id="countryCode" [(ngModel)]="countryCode" (ngModelChange)="onSelectTeacherCountry($event)" *ngIf="this.baseService.isRTL === false">
                                                <option value="" disabled selected>{{'countryCode' | translate}}</option>
                                                <option *ngFor="let country of countries" [value]="country.code">{{country.nameEn}}</option>
                                            </select>
                                            <span class="focus-border"></span>
                                        </div>
                                    </div>
                                </div>
        
        
                                <div class="row row-15">
                                    <div class="col-lg-6">
                                        <div class="form-group" style="margin-top: 15px;">
                                            <input name="email" id="email" autocomplete="off" type="text" [(ngModel)]="teacher.email" required ngModel required #email="ngModel" placeholder="{{'Email' | translate}}" [email]="true">
                                            <span class="focus-border"></span>
                                        </div>
                                        <small class="d-block mt_dec--5" *ngIf="email.errors?.email"><i class="feather-info" style="margin-left: 5px;"></i>{{'emailFormat' | translate}}</small>
                                    </div>
        
        
                                    <div class="col-lg-6">
                                        <div class="form-group" style="margin-top: 15px;">
                                            <input name="pass" #input id="pass" autocomplete="off" type="password" [(ngModel)]="teacher.pass" required ngModel required #pass="ngModel" placeholder="{{'Password' | translate}}" [maxlength]="20" [minlength]="8">
                                            <span class="focus-border"></span>
                                            <i class="feather-eye pass-eye" (click)="changeInput(input)"></i>
                                        </div>
        
                                        <small class="d-block mt_dec--5"><i class="feather-info" style="margin-left: 5px;margin-bottom: 10px;"></i>{{'mustContain' | translate}}</small>
                                    </div>
                                </div>
        
                                <div class="row row-15">
                                    <div class="col-lg-12">
                                        <div class="form-group" style="margin-top: 15px;">
                                            <textarea placeholder="{{'Bio' | translate}}" autocomplete="off" name="bio" id="bio" type="text" [(ngModel)]="teacher.bio" required ngModel required #bio="ngModel" [maxlength]="200"></textarea>
                                            <span class="focus-border"></span>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="col-lg-12">
                                    <div class="form-submit-group">
                                        <button type="submit" class="rbt-btn btn-md btn-gradient hover-transform-none w-100" [class.spinner]="loading" (click)="registerTeacher()" [disabled]="!(teacherForm.valid && teacherForm.dirty) || loading">
                                            <span class="icon-reverse-wrapper">
                                                <span class="btn-text">{{'registerNow' | translate}}</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>

                <div class="tab-pane fade" id="student" role="tabpanel" aria-labelledby="student-tab">
                    <div class="rbt-default-sidebar rbt-shadow-box rbt-gradient-border" style="background: #FFF !important;border:1px solid #ff8c13">
                        <div class="inner">
                            <form #studentForm="ngForm" id="studentForm" novalidate>
                                <div class="row row-15">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input name="name" id="name" type="text" autocomplete="off" [(ngModel)]="student.name" required ngModel required #name="ngModel" placeholder="{{'First Name' | translate}}" [maxlength]="150" pattern="[أ-يa-zA-z ]*">
                                            <span class="focus-border"></span>
                                        </div>
                                        <small class="d-block mt_dec--5" *ngIf="name.errors?.pattern"><i class="feather-info" style="margin-left: 5px;"></i>{{'dontContain' | translate}}</small>
                                    </div>
    
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input name="surname" id="surname" type="text" autocomplete="off" [(ngModel)]="student.surname" required ngModel required #surname="ngModel" placeholder="{{'Last Name' | translate}}" [maxlength]="150" pattern="[أ-يa-zA-z ]*">
                                            <span class="focus-border"></span>
                                        </div>
                                        <small class="d-block mt_dec--5" *ngIf="surname.errors?.pattern"><i class="feather-info" style="margin-left: 5px;"></i>{{'dontContain' | translate}}</small>
                                    </div>
                                </div>
    
                                <div class="row row-15">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input name="userName" id="userName" type="text" autocomplete="off" [(ngModel)]="student.userName" required ngModel required #userName="ngModel" placeholder="{{'User name' | translate}}" [maxlength]="50">
                                            <span class="focus-border"></span>
                                        </div>
                                    </div>
        
                                    <div class="col-lg-4">
                                        <div class="form-group">
                                            <input name="mobile" id="mobile" type="text" autocomplete="off" [(ngModel)]="student.mobile" required ngModel required #mobile="ngModel" placeholder="{{'Phone Number' | translate}}" [maxlength]="10" NumbersOnly>
                                            <span class="focus-border"></span>
                                        </div>
                                    </div>

                                    <div class="col-lg-2">
                                        <div class="form-group">
                                            <select name="countryCode" id="countryCode" [(ngModel)]="countryCode" (ngModelChange)="onSelectTeacherCountry($event)" *ngIf="this.baseService.isRTL === true">
                                                <option value="" disabled selected>{{'countryCode' | translate}}</option>
                                                <option *ngFor="let country of countries" [value]="country.code">{{country.nameAr}}</option>
                                            </select>

                                            <select name="countryCode" id="countryCode" [(ngModel)]="countryCode" (ngModelChange)="onSelectTeacherCountry($event)" *ngIf="this.baseService.isRTL === false">
                                                <option value="" disabled selected>{{'countryCode' | translate}}</option>
                                                <option *ngFor="let country of countries" [value]="country.code">{{country.nameEn}}</option>
                                            </select>
                                            <span class="focus-border"></span>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row row-15">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input name="email" id="email" type="text" autocomplete="off" [(ngModel)]="student.emailAddress" required ngModel required #email="ngModel" placeholder="{{'Email' | translate}}" [email]="true">
                                            <span class="focus-border"></span>
                                        </div>
                                    </div>
        
        
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <input name="pass" #input2 id="pass" autocomplete="off" type="password" [(ngModel)]="student.pass" required ngModel required #pass="ngModel" placeholder="{{'Password' | translate}}" [maxlength]="20" [minlength]="8">
                                            <span class="focus-border"></span>
                                            <i class="feather-eye pass-eye" (click)="changeInputStudent(input2)"></i>
                                        </div>
                                        <small class="d-block mt_dec--5"><i class="feather-info" style="margin-left: 5px;"></i>{{'mustContain' | translate}}</small>
                                    </div>
                                </div>
    
                                <br><br>
    
                                <div class="col-lg-12">
                                    <div class="form-submit-group">
                                        <button type="submit" class="rbt-btn btn-md btn-gradient hover-transform-none w-100" [class.spinner]="loading" (click)="registerStudent()" [disabled]="!(studentForm.valid && studentForm.dirty) || loading">
                                            <span class="icon-reverse-wrapper">
                                                <span class="btn-text">{{'registerNow' | translate}}</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
